import React from "react";
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Select,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const CalendarToolbar = ({
  view,
  onViewChange,
  onPrev,
  onNext,
  onToday,
  periodLabel,
  filterBatch,
  onFilterBatchChange,
  batches,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        flexWrap: "wrap",
        mb: 1.5,
      }}
    >
      <ToggleButtonGroup
        size="small"
        value={view}
        exclusive
        onChange={(_, next) => {
          if (next) onViewChange(next);
        }}
      >
        <ToggleButton value="month">Month</ToggleButton>
        <ToggleButton value="week">Week</ToggleButton>
        <ToggleButton value="day">Day</ToggleButton>
      </ToggleButtonGroup>

      <IconButton size="small" onClick={onPrev}>
        <ChevronLeftIcon />
      </IconButton>
      <IconButton size="small" onClick={onNext}>
        <ChevronRightIcon />
      </IconButton>
      <Button size="small" variant="outlined" onClick={onToday}>
        Today
      </Button>

      <Typography sx={{ fontWeight: 600, ml: { xs: 0, sm: 1 } }}>
        {periodLabel}
      </Typography>

      <Box sx={{ flexGrow: 1 }} />

      <Select
        size="small"
        value={filterBatch}
        onChange={(e) => onFilterBatchChange(e.target.value)}
        sx={{ minWidth: 220 }}
      >
        <MenuItem value="all">All Batches</MenuItem>
        {batches.map((b) => (
          <MenuItem key={b.id} value={b.id}>
            {b.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default CalendarToolbar;

